module.exports = __webpack_public_path__ + "img/empty-notification.832fba73.svg";